import type { RoleKind } from '../display/types.js';
import type { RequestsBatchExportController } from '../selection/useRequestSelection.js';
import type { RequestView } from '../types.js';
import { ClassicRequestsListTable } from './ClassicRequestsListTable.js';
import { RequestsListTable } from './RequestsListTable.js';

export function RequestsListRoleTable(props: {
  role: RoleKind;
  visible: RequestView[];
  now: number;
  narrow: boolean;
  selectedId: string | null;
  isManagerValidating: boolean;
  isError: boolean;
  isInitialLoading: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onOpenRow: (request: RequestView) => void;
  onLoadMore: () => void;
  unreadFor: (id: string) => { unreadCount: number; isMarkedUnread: boolean };
  notificationCountFor: (id: string) => number;
  batchExport?: Pick<
    RequestsBatchExportController,
    'selectionMode' | 'selectedRequestIds' | 'toggle'
  >;
}) {
  const { role, narrow, ...tableProps } = props;
  return role === 'logist_cn' && !narrow ? (
    <ClassicRequestsListTable {...tableProps} />
  ) : (
    <RequestsListTable {...tableProps} narrow={narrow} />
  );
}
